<template>
  <div class="item-preview-several-images">
    <div class="item-image"  v-for="(file,index) in files" :key="index+listPreviewId">
      <div class="img-preview-one-file-container">
        <b-img :src="file.url" alt="Image" class="img-preview-one-file cursor-pointer" @click="openModal(file.id ? getFileUrl(file.url) : file.url)"></b-img>
        <div class="delete-btn-container">
          <button type="button" class="action-btn delete cursor-pointer" @click="deleteFile(index, $event)">
            <i class="ph-custom ph-trash-bold"/>
          </button>
        </div>
      </div>
    </div>

    <b-modal
      v-model="showModal"
      hide-footer
      centered
      size="lg"
      hide-backdrop
      content-class="p-0">
      <template #modal-header>
        <button type="button" class="close" @click="showModal = false" aria-label="Close">
          <i class="ph-custom ph-x-bold secondary-text-color"/>
        </button>
      </template>
      <img :src="selectedImageUrl" alt="Image agrandie" class="w-100">
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'PreviewSeveralImages',

  emits : ['deleteFileInPreview'],

  props: {
    listPreviewId: {
      type: String,
      default: 'preview-several'
    },
    files: {
      type: Array,
      default: []
    },
  },

  data() {
    return {
      showModal: false,
      selectedImageUrl: null
    }
  },


  methods: {
    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },

    openModal(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.showModal = true;
    },

    deleteFile(index, event){
      //il faut vérifier pointerType car une enter key sur une autre entrée du formulaire peut faire office de 'click sur le prochain btn' avec un pointerType = "" au lieu de "mouse" ou "touch" par ex
      //et si le prochain btn est celui de suppression d'un preview file comme ici -> on prend pas en compte cet event !
      if(event && event.pointerType !== "") {
        this.$emit('deleteFileInPreview', index)
      }
    },
  },
}
</script>

<style scoped>

.item-preview-several-images {
  display: flex;
  flex-wrap: wrap;
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  flex: 0 0 100%;
  max-width: 100%;
  gap: 0.5em;
}

.item-image {
  position: relative;
  -ms-flex: 0 0 48%;
  -webkit-box-flex: 0;
  flex: 0 0 48%;
  max-width: 48%;
  max-height: 150px;
  border-radius: 10px;
  overflow: hidden;
}

.img-preview-one-file-container {
  min-height: 45px;
  max-height: 100%;
  display: flex;
  justify-content: center;
}

.img-preview-one-file {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  align-self: center;
}

.img-preview-one-file-container {
  min-height: 45px;
  max-height: 100%;
  display: flex;
  justify-content: center;
}

.img-preview-one-file {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  align-self: center;
}

.delete-btn-container {
  position: absolute;
  top: 10px;
  right: 0;
  margin-right: 0.5em;
}

.action-btn.delete {
  background-color: var(--main-red-medium);
  color: var(--main-black-dark);
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/PreviewSeveralImages.vue